// extracted by mini-css-extract-plugin
export default {"cls1":"AddPayee-OnboardingPayeeStepper_cls1__-JoBl","cls2":"AddPayee-OnboardingPayeeStepper_cls2__PQJb3 AddPayee-OnboardingPayeeStepper_cls1__-JoBl"};